'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import usageTracker from '../../lib/usageTracker';
import { LanguageCTALinks } from '../../constants/TrialConstants';
import Logo from '../Logo';
import ebook from 'bender-url!../../../img/ebook.svg';
import { parseUtmParams } from '../../util/Urls';

const AltLangTrialCtaPage = ({
  websiteUrl
}) => {
  const lang = window.I18N_MANUAL_LANG;
  const GUIDE_LINK = `${LanguageCTALinks[lang]}&${parseUtmParams()}`;

  const handleCtaClick = () => {
    const eventKey = 'freeGuideClick';
    const action = 'clicked-get-guide-button';
    usageTracker.log(eventKey, {
      action,
      websiteUrl,
      source: 'results-footer'
    });
  };

  return /*#__PURE__*/_jsx("div", {
    className: "trial-cta-page",
    "data-reagan-selector": "trial-cta-page",
    children: /*#__PURE__*/_jsx("div", {
      className: "wsg-container trial-cta-container",
      children: /*#__PURE__*/_jsxs("div", {
        className: "cta-container",
        children: [/*#__PURE__*/_jsx("div", {
          className: "cta-image-left",
          children: /*#__PURE__*/_jsx("img", {
            src: ebook
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "cta-info-right",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "trial-cta-header",
            children: [/*#__PURE__*/_jsx("div", {
              className: "product-logo",
              children: /*#__PURE__*/_jsx(Logo, {})
            }), /*#__PURE__*/_jsx("div", {
              className: "header",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                className: "header",
                message: "trialCtaPage.header"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "paragraph",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "trialCtaPage.cmsParagraph-alt"
            }), ";"]
          }), /*#__PURE__*/_jsx("div", {
            className: "trial-cta-button",
            children: /*#__PURE__*/_jsx("a", {
              className: "button white",
              onClick: handleCtaClick,
              href: GUIDE_LINK,
              target: "_blank",
              rel: "noopener noreferrer",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: 'trialBanner.ctaButtonGetGuide'
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "microcopy"
          })]
        })]
      })
    })
  });
};

AltLangTrialCtaPage.propTypes = {
  websiteUrl: PropTypes.string.isRequired
};
export default AltLangTrialCtaPage;